import React, { useState, useContext, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import UserContext from '../../context/user';
import Chip from '@mui/material/Chip';
import { DirectionContext } from '../../context/DirectionProvider';
import { Close } from '@mui/icons-material';
import { sortTranslated } from '../shared/util';

export const MultiSelect = (props) => {
    const UserInfo = React.useContext(UserContext);
    const [value, setValue] = React.useState(props.entity)
    const [selectList, setSelectList] = React.useState(props.selectList)

    const newListFilter = JSON.parse(JSON.stringify(selectList))

    const direction = useContext(DirectionContext);
     

    newListFilter[0].labelValue = newListFilter[0].label === 'Country' ? JSON.parse(JSON.stringify(UserInfo.countries)) : newListFilter[0].labelValue;
    const [filter, setFilter] = useState(UserInfo ? (UserInfo.countries[0] === 'global' ? selectList : newListFilter) : []);

    useEffect(() => {
        setSelectList(props.selectList);
        const newListFilter = JSON.parse(JSON.stringify(props.selectList))
        newListFilter[0].labelValue = newListFilter[0].label === 'Country' ? JSON.parse(JSON.stringify(UserInfo.countries)) : newListFilter[0].labelValue;
        setFilter(UserInfo ? (UserInfo.countries[0] === 'global' ? props.selectList : newListFilter) : []);
        setValue(props.entity);
    }, [props.selectList])
    
    const formatedOptions = filter.reduce((res, row) => {
        const countryRow = [];
        
        row.labelValue.map((name) => {
            countryRow.push({
                type: row.label,
                name: name
            });
            return [];
        });
        res = res.concat(countryRow);
        
        return res;
        
        
    }, []);

    
    const changeSelect = (event, value) => {
        let val = value.flatMap(val => ({
            ...val,
            name: val && val?.name && val?.name?.split(' | ')[val?.name?.split(' | ').length - 1]
        }))
        setValue(val);
        props.changedEntity(val);
    }
    return (
        <React.Fragment>
            <Autocomplete
                disabled={props.disabled}
                className="container col-md-12 col-sm-12 col-lg-12 px-0 search-text"
                multiple
                limitTags={3}
                clearOnEscape={true}
                disableCloseOnSelect
                id="search-text"
                size="small"
                options={sortTranslated(formatedOptions)}
                getOptionLabel={(option) => option.name.split(' | ')[0]}
                groupBy={(option) =>option.type}
                onChange={(event, value) => changeSelect(event, value)}
                isOptionEqualToValue={(option, value) => option.name === value.name}
                value={value ? value.flatMap(val => formatedOptions.find(opt => opt.name.split(' | ')[opt.name.split(' | ').length - 1] == val.name)) : []}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        size='small'
                        
                        sx={{direction, padding:'3px'}}
                        deleteIcon={<Close sx={{margin: '0 !important'}}/>}
                        label={<span className='_wg-exclude'>{option.name}</span>}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                renderInput={(params) => (
                    <>
                        <TextField {...params}
                            helperText=" "
                            variant="standard"
                            className="w-100"
                            id="search-text"
                            label={props.name}
                            placeholder="" 
                        />

                    </>
                )}
                
            />
        </React.Fragment>
    )
}